import { type FC } from 'react'
import classNames from 'classnames'
import { Tooltip } from 'shared/ui/Tooltip'
import { Icon, type IIconsVector } from 'shared/ui/Icon'
import { truthy } from 'shared/lib'
import { type internalAutomatedInfoType, type IResponseMessageSource } from 'entities/Message'
import { type automatedInfo, automatedInfoIconMap, automatedInfoTitleMap } from './types.ts'

import styles from './styles.module.scss'

type IAutomatedAvatarProps = {
  size?: 'small'
  withTooltip?: boolean
  automatedInfo?: automatedInfo | null
  source?: IResponseMessageSource | null
}

export const AutomatedAvatar: FC<IAutomatedAvatarProps> = ({
  size,
  withTooltip,
  automatedInfo,
  source,
}) => {
  const iconSize = size === 'small' ? 16 : 22
  const defaultIcon: IIconsVector = 'bot'

  let icon: IIconsVector = defaultIcon
  let iconColor = undefined
  let tooltipLabel = 'Salesmsg bot'

  if (automatedInfo) {
    const { isInternal, type, source, name } = automatedInfo

    const automatedIcon = isInternal
      ? type && automatedInfoIconMap[type]
      : source && automatedInfoIconMap[source]

    if (automatedIcon) {
      icon = automatedIcon
    }

    if (isInternal) {
      iconColor = 'var(--content-brand-primary)'
    }

    const typeLabel = type && automatedInfoTitleMap[type]

    let sourceLabel = null
    const excludedSourceLabels: internalAutomatedInfoType[] = [
      'ai',
      'broadcast',
      'keyword',
      'campaign',
    ]

    if (type && !excludedSourceLabels.includes(type)) {
      sourceLabel = source && automatedInfoTitleMap[source]
    }
    const left = [sourceLabel, typeLabel].filter(truthy).join(' ')
    const right = name || ''

    tooltipLabel = [left, right].filter(truthy).join(': ')
  } else if (source) {
    if (source === 'agentforce') {
      tooltipLabel = 'Salesforce Agentforce'
    }
    if (source === 'mcp_server') {
      tooltipLabel = 'Salesmsg MCP'
    }
  }

  const content = (
    <div className={classNames(styles.wrap, !automatedInfo && styles.bg, size && styles[size])}>
      <Icon icon={icon} fontSize={iconSize} color={iconColor} />
    </div>
  )

  if (withTooltip) {
    return (
      <Tooltip label={tooltipLabel} placement={'top'}>
        {content}
      </Tooltip>
    )
  }
  return content
}
